import { createStructuredSelector } from 'reselect';
import { fetchRAGState, selectEditMode } from './RecommendGrantPageSelectors';

const selectRecentCharities = (state) => {
  const { recentCharities } = fetchRAGState(state);
  return recentCharities;
};

const selectSavedCharities = (state) => {
  const { savedCharities } = fetchRAGState(state);
  return savedCharities;
};

const selectGrantedCharityLoading = (state) => {
  const { grantedCharity } = fetchRAGState(state);
  return grantedCharity.isLoading;
};

const selectSavedCharityLoading = (state) => {
  const { savedCharity } = fetchRAGState(state);
  return savedCharity.isLoading;
};

const selectSearchCharityLoading = (state) => {
  const { searchCharity } = fetchRAGState(state);
  return searchCharity.isLoading;
};

const selectSearchCharityData = (state) => {
  const { searchCharity } = fetchRAGState(state);
  return searchCharity.data;
};

const selectSearchCharityIsCharitySearch = (state) => {
  const { searchCharity } = fetchRAGState(state);
  return searchCharity.isCharitySearch;
};

const selectGrantHistory = (state) => {
  const { grantHistory } = fetchRAGState(state);
  return grantHistory;
};

const selectPendingGrants = (state) => {
  const { pendingGrants } = fetchRAGState(state);
  return pendingGrants;
};

const selectPendingActiveSchedule = (state) => {
  const { pendingActiveSchedule } = fetchRAGState(state);
  return pendingActiveSchedule;
};

const selectSearchTerm = (state) => {
  const { searchTerm } = fetchRAGState(state);
  return searchTerm;
};

const selectGeminiSearchTerm = (state) => {
  const { geminiSearchTerm } = fetchRAGState(state);
  return geminiSearchTerm;
};

const selectSearchGeminiData = (state) => {
  const { searchGemini } = fetchRAGState(state);
  return searchGemini.data;
};

const selectSearchGeminiIsGeminiSearch = (state) => {
  const { searchGemini } = fetchRAGState(state);
  return searchGemini.isGeminiSearch;
};

const selectSearchCharityIsGeminiSearch = (state) => {
  const { searchCharity } = fetchRAGState(state);
  return searchCharity.guidestarSearchCount;
};

const selectScheduleHistory = (state) => {
  const { scheduleHistory } = fetchRAGState(state);
  return scheduleHistory;
};

const selectPendingGrantsLoading = (state) => {
  const { pendingGrantsLoading } = fetchRAGState(state);
  return pendingGrantsLoading;
};

const selectGrantHistoryLoading = (state) => {
  const { grantHistoryLoading } = fetchRAGState(state);
  return grantHistoryLoading;
};

const selectSearchGeminiStringResponse = (state) => {
  const { searchGemini } = fetchRAGState(state);
  return searchGemini.searchGeminiStringResponse;
};

const selectAgreementHistory = (state) => {
  const { agreementHistory } = fetchRAGState(state);
  return agreementHistory;
};

const selectPendingAgreements = (state) => {
  const { pendingAgreements } = fetchRAGState(state);
  return pendingAgreements;
};

const selectServerDown = (state) => {
  const { searchCharity } = fetchRAGState(state);
  return searchCharity.serverDown;
}

export const charitySelectDerivedStates = createStructuredSelector({
  recentGrants: selectRecentCharities,
  savedCharities: selectSavedCharities,
  isLoadingGranted: selectGrantedCharityLoading,
  isLoadingSaved: selectSavedCharityLoading,
  isLoadingCharity: selectSearchCharityLoading,
  searchCharity: selectSearchCharityData,
  isCharitySearch: selectSearchCharityIsCharitySearch,
  grantHistory: selectGrantHistory,
  pendingGrants: selectPendingGrants,
  pendingActiveSchedule: selectPendingActiveSchedule,
  searchTermData: selectSearchTerm,
  geminiSearchTerm: selectGeminiSearchTerm,
  searchGeminiData: selectSearchGeminiData,
  isGeminiSearch: selectSearchGeminiIsGeminiSearch,
  editMode: selectEditMode,
  guidestarSearchCount: selectSearchCharityIsGeminiSearch,
  scheduleHistory: selectScheduleHistory,
  pendingGrantsLoading: selectPendingGrantsLoading,
  grantHistoryLoading: selectGrantHistoryLoading,
  searchGeminiStringResponse: selectSearchGeminiStringResponse,
  agreementHistory: selectAgreementHistory,
  pendingAgreements: selectPendingAgreements,
  serverDown: selectServerDown,
});
